<ul class="nav nav-pills vm-tab-pill">
  <ng-container
    *ngIf="iscomplex; then complex_data; else non_complex_data"
  ></ng-container>
  <ng-template #non_complex_data>
    <li
      *ngFor="let item of data"
      class="nav-item vm-tab-pill__item"
      [ngClass]="{ active: item.text == selectedbutton, isDisabled: disabled }"
    >
      <a class="nav-link vm-tab-pill__link" (click)="buttonClick(item)">
        <span *ngIf="item.value != ''">
          <img src="{{ item.value }}"   alt="image" height="16px" width="16px" />
        </span>
        {{ item.text }}
      </a>
    </li>
  </ng-template>
  <ng-template #complex_data>
    <li
      *ngFor="let item of data"
      class="nav-item vm-tab-pill__item"
      [ngClass]="{
        active: item[textfield] == selectedbutton,
        isDisabled: disabled
      }"
    >
      <a class="nav-link vm-tab-pill__link" (click)="buttonClick(item)">
        <span *ngIf="item[valuefield] != ''">
          <img src="{{ item[valuefield] }}"   alt="image" height="16px" width="16px" />
        </span>
        {{ item[textfield] }}
      </a>
    </li>
  </ng-template>
</ul>
